import { Box, type SxProps } from '@mui/system';

type RootProps = {
  children: React.ReactNode;
  sx?: SxProps;
} & React.HTMLAttributes<HTMLDivElement>;

export const Root = ({ children, sx = {}, ...props }: RootProps) => {
  return (
    <Box
      sx={{
        padding: '1rem',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        ...sx,
      }}
      {...props}
      data-testid='layout-root'
    >
      {children}
    </Box>
  );
};

export const RootForThumbnail = ({ children, sx = {}, ...props }: RootProps) => {
  return (
    <Root sx={{ backgroundColor: 'white', padding: '0.5rem', ...sx }} {...props}>
      {children}
    </Root>
  );
};
